import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';

interface Menu {
  label: string;
  route: string;
}

export const menuItems: Menu[] = [
  {
    label: 'Homepage',
    route: PAGE_ROUTES.HOME,
  },
  {
    label: 'Services',
    route: PAGE_ROUTES.SERVICES,
  },
  {
    label: 'Careers',
    route: PAGE_ROUTES.CAREERS,
  },
  {
    label: 'About Us',
    route: PAGE_ROUTES.ABOUT_US,
  },
];
